import React, { useEffect, useState } from "react";
import "./OrderList.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import search from "../../../assests/search.svg";
import eyeIcon from "../../../assests/eyeIcon.svg";
import filterIcon from "../../../assests/filterIcon.svg";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import uploadsvg from "../../../assests/uploadsvg.svg";
import unableImage from "../../../assests/unableImage.svg";
import retryicon from "../../../assests/retryicon.svg";
import emotions7 from "../../../assests/emotions7.svg";
import moment from "moment-timezone";
import Table from "react-bootstrap/Table";

const OrdersListComp = ({
  filteredCityList,
  onSearchInputChange,
  loading,
  fetchOrderListNext,
  data,
  handleDateChange,
  handleOpen,
  pickDate,
  rowColors,
  handleDrag,
  handleDrop,
  onButtonClick,
  inputRef,
  imageDropped,
  previewImage,
  handleClickImg,
  handleCloseD,
  handleChangeImage,
  orderFound,
  handleRetry,
  handleClickOpen,
  showFileInput,
  open,
  handleFocus,
  handleBlur,
  onSearchInputKeyDown,
  searchOrderValue,
  isLoading,
  searchOption,
  tableContainerRef,
  orderSearchViaCity,
  handleClose,
  openFilter,
  filteredList,
  handleOpenAmount,
  openFilterAmount,
  orderSearchViaAmount,

  handleApply,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  onSearchClick,
  handleCheckboxChange,
  selectedCity,
  selectedAmount,
  removeDuplicates,
  handleCancelSelection,
  handleEndTimeChange,
  handleStartTimeChange,
  searchAmountValue,
  handleAmountInputChange,
  handleApplyFilter
}) => {
  const navigate = useNavigate();
  const { orderid } = useParams();
  const [showDatePicker, setShowDatePicker] = useState(false);


  const [ctlist, setctlist] = useState(null);
  const uniqueCities = removeDuplicates(ctlist, "city");
  const uniqueAmounts = removeDuplicates(ctlist, "amount");

  useEffect(() => {
    if (!ctlist || !ctlist[0]) {
      setctlist(filteredList);
    }
  }, [filteredList]);



  const handleRowClick = (e, orderid) => {
    navigate(`/home/ordersview/${orderid}`);
  };
  const arrowClick = () => {
    navigate("/");
  };

  return (
    <div className="orders-container">
      {isLoading ? (
        <div className="loading-spinner">
          <CircularProgress />
        </div>
      ) : (
        <>
          <Sidebar />

          <div className="orders-content">
            <div className="orders-header">
              <button onClick={arrowClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Orders</h1>
            </div>

            <div className="search-section">
              <div className="search-bar">
                <input
                  type="search"


                  placeholder="Search by Mobile Number / Search by Order ID / Mini Order ID"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={searchOrderValue}
                  onChange={onSearchInputChange}
                  onKeyDown={onSearchInputKeyDown}
                />
                <button className="search-button" onClick={onSearchClick}>
                  <img src={search} alt="Search" />
                </button>
              </div>

              <Button
                onClick={handleClickOpen}
                // className="upload-button"
                variant="contained"
              >
                <img src={uploadsvg} alt="Upload" />
                <span>Upload Screenshot</span>
              </Button>
            </div>

            <div className="order-filters-section">
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <div className="order-date-filters">
                  <DatePicker
                    label="Select Date"
                    value={pickDate}
                    onChange={handleDateChange}
                    maxDate={moment()}
                    renderInput={(params) => (
                      <TextField {...params} className="filter-input" />
                    )}
                  />

                  <TimePicker
                    label="Start Time"
                    value={startTime}
                    onChange={handleStartTimeChange}
                    renderInput={(params) => (
                      <TextField {...params} className="filter-input" />
                    )}
                  />

                  <TimePicker
                    label="End Time"
                    value={endTime}
                    onChange={handleEndTimeChange}
                    renderInput={(params) => (
                      <TextField {...params} className="filter-input" />
                    )}
                  />
                </div>
              </LocalizationProvider>

              <div className="amount-filter">
               <label>Amount</label>
                <div className="amount-input">
              
                  Rs.
                  <input
                    type="number"
                    placeholder="___"
                    value={searchAmountValue}
                    onChange={handleAmountInputChange}
                    maxLength={5}
                  />
                </div>
              </div>

              <div className="filter-buttons">
                <Button
                  onClick={handleApplyFilter}
                  variant="contained"
                  className="apply-button"
                >
                  Apply
                </Button>
                <Button
                  onClick={handleCancelSelection}
                  variant="outlined"
                  className="reset-button"
                >
                  Reset
                </Button>
              </div>
            </div>

            <div className="orders-table-container" ref={tableContainerRef}>
              <Table responsive className="orders-table">
                <thead>
                  <tr>
                    <th>Order Date & Time</th>
                    <th>Order ID</th>
                    <th>Mini order ID</th>
                    <th>Phone Number</th>
                    <th>

                      <span style={{ marginLeft: "60px" }}>City</span>
                    </th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList && filteredList.length > 0 ? (
                    filteredList.map((el, index) => (
                      <tr
                        key={el.id}
                        style={{ cursor: "pointer" }}
                        className="orders-view"
                        onClick={(e) => handleRowClick(e, el.id)}
                      >
                        <td>{moment.utc(el.createdAt).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A")}</td>
                        <td>{el.id}</td>
                        <td>{el.dcCode}</td>
                        <td>{el.phone || "N/A"}</td>
                        <td>{el.city}</td>
                        <td>{el.amount}</td>
                        <td>
                          <img src={eyeIcon} alt="View" className="orders-eye-icon" />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", border: "none" }}>
                        <div className="no-orders">
                          <img src={emotions7} alt="No orders" />
                          <p>No Order Found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>

          {/* Upload Screenshot Dialog */}
          <Dialog
            open={open}
            onClose={handleCloseD}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              Upload Screenshot
              <IconButton onClick={handleCloseD} className="close-button">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {orderFound ? (
                <div className="upload-container">
                  <div
                    className={`drop-zone ${previewImage ? 'has-image' : ''}`}
                    onDrop={handleDrop}
                    onDragOver={handleDrag}
                    onClick={(e) => onButtonClick(e, "box")}
                  >
                    {previewImage ? (
                      <img src={previewImage} alt="Preview" />
                    ) : (
                      <p>
                        Drop screenshot here, or <button>Browse</button>
                      </p>
                    )}
                  </div>

                  {previewImage && (
                    <Button
                      onClick={handleClickImg}
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={isLoading}
                    >
                      {isLoading ? <CircularProgress size={24} /> : "Submit"}
                    </Button>
                  )}

                  <input
                    ref={inputRef}
                    type="file"
                    onChange={handleChangeImage}
                    style={{ display: "none" }}
                  />
                </div>
              ) : (
                <div className="not-found-container">
                  <img src={unableImage} alt="Unable to find" />
                  <h4>Unable to find order id</h4>
                  <button onClick={handleRetry}>
                    Retry <img src={retryicon} alt="Retry" />
                  </button>
                </div>
              )}
            </DialogContent>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default OrdersListComp;